/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs */



/**
* | output |
* | --- |
* | "Position Bottom Center" |
*
* @param {Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_bottom_center = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner en bas au centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position unten Mitte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione in basso al centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Положение: Нижний центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición inferior central")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置：底部中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("下中央に配置する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति: निचला केंद्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição: Centro Inferior")
	return /** @type {LocalizedString} */ ("Position Bottom Center")
});